import { Option, some } from 'fp-ts/lib/Option';
import { getLang } from 'sdi/app';
import miniMap from 'sdi/map/mini';
import { GeometryObject } from 'sdi/source';

// The circle is symmetric in the minimap bbox, so its center maps to ~the
// canvas center. Draw the radius label there, just right of the center.
const drawCenterLabel = (dataUrl: string, label: string): Promise<string> =>
    new Promise(resolve => {
        const img = new Image();
        img.onload = () => {
            const canvas = document.createElement('canvas');
            canvas.width = img.width;
            canvas.height = img.height;
            const ctx = canvas.getContext('2d');
            if (!ctx) {
                resolve(dataUrl);
                return;
            }
            ctx.drawImage(img, 0, 0);

            const cx = img.width / 2;
            const cy = img.height / 2;
            ctx.font = '16px sans-serif';
            ctx.textAlign = 'left';
            ctx.textBaseline = 'middle';

            const padX = 6;
            const padY = 4;
            const textH = 16;
            const textW = ctx.measureText(label).width;
            const boxX = cx + 8;

            ctx.fillStyle = 'rgba(255, 255, 255, 0.85)';
            ctx.strokeStyle = '#000';
            ctx.lineWidth = 1;
            ctx.beginPath();
            ctx.rect(
                boxX - padX,
                cy - textH / 2 - padY,
                textW + 2 * padX,
                textH + 2 * padY,
            );
            ctx.fill();
            ctx.stroke();

            ctx.fillStyle = '#000';
            ctx.fillText(label, boxX, cy);

            resolve(canvas.toDataURL('image/png'));
        };
        img.onerror = () => resolve(dataUrl);
        img.src = dataUrl;
    });

export const generateMiniMap = (
    geom: GeometryObject,
    radius: Option<number>,
): Promise<Option<string>> =>
    miniMap(
        `https://geoservices-basemap.irisnet.be/geoserver/BaseMaps/ows?request=GetCapabilities&service=WMS&version=1.3.0&language=${getLang()}`,
        {
            WIDTH: 512,
            HEIGHT: 512,
        },
    )(geom).then(opt =>
        radius.foldL(
            () => Promise.resolve(opt),
            r =>
                opt.foldL(
                    () => Promise.resolve(opt),
                    url => drawCenterLabel(url, `${r} m`).then(some),
                ),
        ),
    );
